import { EntityQuery } from 'breeze-client';

const baseQuery = EntityQuery.from('GroupMemberships');

export const groupMembershipQueries = {
  selectAll: baseQuery
};
